<template>
    <div>
        <v-row dense justify="center">
            <v-col sm="6" md="6">
                <v-autocomplete
                    :items="inst_list"
                    v-model="inst_data"
                    item-text="name"
                    label="Search Employee"
                    dense
                    return-object
                    rounded
                    color="#0f2027"
                    outlined
                    class="ma-2 no-display"
                    :loading="comp_load"
                    placeholder="Search by employee code or name"
                ></v-autocomplete>
            </v-col>
        </v-row>
         <v-row justify="center" dense v-if="inst_data!=null">
                            <v-radio-group v-model="radios" mandatory row class="ma-2 no-display">
                                <v-radio label="Both" value="both" color="#0f2027"></v-radio>
                                <v-radio label="Front Copy" value="front" color="#0f2027"></v-radio>
                                <v-radio label="Back Copy" value="back" color="#0f2027"></v-radio>
                            </v-radio-group>
                             <v-btn @click="icardGenerate()"  class="button no-display">Get Icard</v-btn>
         </v-row>
        <v-row dense>
            <v-btn v-if="icard_data!=''" class="ma-2 no-display" tile outlined color="warning" @click="print()"> <v-icon left>mdi-printer</v-icon> Print <v-icon right></v-icon> </v-btn>
        </v-row>

        <v-row dense justify="center">
            <!-- <v-card class="box" v-if="icard_data!=''" flat style="height: 15%; width: 25%;">
                    <v-row>
                        <v-col cols="12" sm="2" md="2">
                     <img :src="icard_data[0].logo" height="100" width="100" alt="logo" /> 
                        </v-col>
                        <v-col cols="12" sm="10" md="10">
                     <span v-html="icard_data[0].heading"> {{icard_data[0].heading}}</span> 
                        </v-col>
                    </v-row>
                    <v-row dense class="black--text" justify="center">
                        <h2>{{icard_data[0].emp_code}}</h2>
                    </v-row>
                    <center><v-img :src="icard_data[0].profile_photo_path" height="50%" width="50%"> </v-img></center>
                       <v-img style="height:130px;width:100%" :src="icard_data[0].watermark">
                            <center>
                            <div class="text-center white--text pt-10 mt-10"><h2>{{icard_data[0].name}}</h2></div>
                            <div class="text-center white--text"><h2>{{icard_data[0].designation}}</h2></div>
                            <div style="position:absolute; bottom:0px;" class="white--text"><strong> Authorised Signatory</strong></div>
                             </center>
                        </v-img>
            </v-card> -->
            <div class="card mr-5" v-if="icard_data!='' && radios == 'front'" style="width: 23rem; height: 12rem;">
                <div class="card-body box">
                <v-row dense>
                    <v-col cols="12" sm="2" md="2">
                        <img :src="icard_data[0].logo" height="100" width="100" alt="logo" />
                    </v-col>
                    <v-col cols="12" sm="10" md="10">
                        <span v-html="icard_data[0].heading"> {{icard_data[0].heading}}</span>
                    </v-col>
                </v-row>
                <!-- <v-row dense class="black--text" justify="center"> -->
                    
                <center><h2>{{icard_data[0].emp_code}}</h2></center>
                <!-- </v-row> -->
                <div class="empimg">
               <center><img :src="icard_data[0].profile_photo_path" class="box1" style="width:60%;height:200px" /> </center>
                </div>
                <v-img height="135%" :src="icard_data[0].watermark">
                    <center>
                        <div class="text-center white--text pt-10 mt-10"><h2>{{icard_data[0].name}}</h2></div>
                        <div class="text-center white--text"><h2>{{icard_data[0].designation}}</h2></div>
                          <!-- <div style="position: absolute; bottom: 0px; margin-right: 24%;" class="white--text"><img :src="icard_data[0].sign" style="width:75%;height:60px" alt="logo" /></div> -->
                          <div style="position: absolute; bottom: 0px; margin-right: 40%; margin-left:-17px" class="white--text"><img :src="icard_data[0].sign" style="width:78%;height:60px" alt="logo" /></div>
                          <div style="position: absolute; bottom: 0px;" class="white--text"><strong> Authorised Signatory</strong></div>
                    </center>
                </v-img>
                </div>
            </div>
            <!-- <v-card class="pagebreak box" v-if="icard_data!=''" flat style="height: 15%; width: 25%;"> -->
            <!-- <v-btn v-if="icard_data!=''" class="ma-2 no-display" tile outlined color="warning" @click="print1()"> <v-icon left>mdi-printer</v-icon> Print 1 <v-icon right></v-icon> </v-btn> -->
            <div id="print" class="card" v-if="icard_data!='' && radios == 'back'" style="width: 23rem; height: 12rem;">
                   <div class="card-body box">
                <v-img  :src="icard_data[0].watermark_back"></v-img>
                <v-row justify="center">
                    <v-col cols="12" sm="12" md="12">
                        <div class="ml-1" style="font-size: 0.83em;">
                            <strong>Date of Birth :- </strong> {{icard_data[0].emp_dob}}<br />
                            <strong>Blood Group :- </strong>{{icard_data[0].emp_blood_group}}<br />
                            <strong> Contact No. :- </strong> {{icard_data[0].emp_contact}}<br />
                            <strong>Email :- </strong>{{icard_data[0].emp_email}}<br />
                            <!-- <strong>Address :- </strong>{{icard_data[0].emp_address}}<br /> -->
                        </div>
                        <div class="ml-1" style="font-size: 0.83em;height:60px">
                            <strong>Address :- </strong>{{icard_data[0].emp_address}}<br />
                        </div>
                    </v-col>
                </v-row>
                <strong>Instruction</strong>
                <hr />
                <v-row dense class="ml-3" v-for="(i,index) in icard_data[0].instruction" :key="index">
                    <h5>{{index + 1}} . {{i.topic}}</h5>
                </v-row>
               <center> <barcode height="20" width="1" v-model="icard_data[0].emp_code" v-bind:value="icard_data[0].emp_code"> </barcode></center>
                <div style="background: #0095cb;">
                    <v-row class="ml-1 pt-3">
                        <h5>{{icard_data[0].school_name}}</h5>
                    </v-row>
                    <hr />
                    <v-row class="ml-1">
                        <h5>{{icard_data[0].school_address}}</h5>
                    </v-row>
                    <v-row class="ml-1">
                        <h5>Contact No. :- {{icard_data[0].school_contact}}</h5>
                    </v-row>
                    <v-row class="ml-1">
                        <h6>Email :- {{icard_data[0].email}}</h6>
                        <v-spacer></v-spacer>
                        <h6>Website :- {{icard_data[0].website}}</h6>
                    </v-row>
                </div>
                   </div>
            </div>
            <!-- </v-card> -->
        </v-row>
        <v-row dense justify="center" v-if="icard_data!='' && radios == 'both'">
            <div class="card mr-5" v-if="icard_data!=''" style="width: 23rem; height: 12rem;">
                <div class="card-body box">
                <v-row dense>
                    <v-col cols="12" sm="2" md="2">
                        <img :src="icard_data[0].logo" height="100" width="100" alt="logo" />
                    </v-col>
                    <v-col cols="12" sm="10" md="10">
                        <span v-html="icard_data[0].heading"> {{icard_data[0].heading}}</span>
                    </v-col>
                </v-row>
                <!-- <v-row dense class="black--text" justify="center"> -->
                <center><h2>{{icard_data[0].emp_code}}</h2></center>
                <!-- </v-row> -->
                <div class="empimg">
                <center><img :src="icard_data[0].profile_photo_path" class="box1" style="width:60%;height:200px" /> </center>
                </div>
                <v-img height="135%" :src="icard_data[0].watermark">
                    <center>
                        <div class="text-center white--text pt-10 mt-10"><h2>{{icard_data[0].name}}</h2></div>
                        <div class="text-center white--text"><h2>{{icard_data[0].designation}}</h2></div>
                        <!-- <div style="position: absolute; bottom: 0px;" class="white--text"><img :src="icard_data[0].sign" class="pb-3 ml-5" style="width:100%;height:60px" alt="logo" /></div> -->
                          <div style="position: absolute; bottom: 0px; margin-right: 40%; margin-left:-17px" class="white--text"><img :src="icard_data[0].sign" style="width:78%;height:60px" alt="logo" /></div>
                          <div style="position: absolute; bottom: 0px;" class="white--text"><strong> Authorised Signatory</strong></div>
                    </center>
                </v-img>
                </div>
            </div>
            <!-- <v-card class="pagebreak box" v-if="icard_data!=''" flat style="height: 15%; width: 25%;"> -->
            <!-- <v-btn v-if="icard_data!=''" class="ma-2 no-display" tile outlined color="warning" @click="print1()"> <v-icon left>mdi-printer</v-icon> Print 1 <v-icon right></v-icon> </v-btn> -->
            <div id="print" class="card" v-if="icard_data!=''" style="width: 23rem; height: 12rem;">
                   <div class="card-body box">
                <v-img   :src="icard_data[0].watermark_back"></v-img>
                <v-row justify="center">
                    <v-col cols="12" sm="12" md="12">
                        <div class="ml-1" style="font-size: 0.83em;">
                            <strong>Date of Birth :- </strong> {{icard_data[0].emp_dob}}<br />
                            <strong>Blood Group :- </strong>{{icard_data[0].emp_blood_group}}<br />
                            <strong> Contact No. :- </strong> {{icard_data[0].emp_contact}}<br />
                            <strong>Email :- </strong>{{icard_data[0].emp_email}}<br />
                            <!-- <span style="height:80px"><strong>Address :- </strong>{{icard_data[0].emp_address}}<br /></span> -->
                        </div>
                        <div class="ml-1" style="font-size: 0.83em;height:60px">
                            <strong>Address :- </strong>{{icard_data[0].emp_address}}<br />
                        </div>
                    </v-col>
                </v-row>
                <strong>Instruction</strong>
                <hr />
                <v-row dense class="ml-3" v-for="(i,index) in icard_data[0].instruction" :key="index">
                    <h5>{{index + 1}} . {{i.topic}}</h5>
                </v-row>
               <center> <barcode height="20" width="1" v-model="icard_data[0].emp_code" v-bind:value="icard_data[0].emp_code"> </barcode></center>
                <div style="background: #0095cb;">
                    <v-row class="ml-1 pt-3">
                        <h5>{{icard_data[0].school_name}}</h5>
                    </v-row>
                    <hr />
                    <v-row class="ml-1">
                        <h5>{{icard_data[0].school_address}}</h5>
                    </v-row>
                    <v-row class="ml-1">
                        <h5>Contact No. :- {{icard_data[0].school_contact}}</h5>
                    </v-row>
                    <v-row class="ml-1">
                        <h6>Email :- {{icard_data[0].email}}</h6>
                        <v-spacer></v-spacer>
                        <h6>Website :- {{icard_data[0].website}}</h6>
                    </v-row>
                </div>
                   </div>
            </div>
            <!-- </v-card> -->
        </v-row>
    </div>
</template>
<script>
    import axios from "axios";
    import VueBarcode from "vue-barcode";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
        components: {
            barcode: VueBarcode,
        },
        data: () => ({
            comp_load: false,
            inst_list: null,
            radios: null,
            inst_data: null,
            icard_data: [],
            barcodeValue: "test",
        }),
        mounted() {
            this.comp_load = true;
            this.inst_data = null;
            axios
                .post("/RoleManagement/getAllEmployee")
                .then((res) => {
                    if (res.data.msg == "200") {
                        this.inst_list = res.data.inst_list;
                    } else {
                        alert("Somthing went wrong!!!");
                    }
                })
                .catch((error) => {
                    alert("Somthing went wrong!!!");
                })
                .finally(() => {
                    this.comp_load = false;
                });
        },
        methods: {
            // print1(){
            //     window.print();      
            // },
            print() {
                this.$store.state.drawer = false;
                let that = this;
                window.onafterprint = function () {
                    that.$store.state.drawer = true;
                };
                setTimeout(function () {
                    window.print();
                }, 100);
            },
            icardGenerate() {
                const data = {
                    inst_data: this.inst_data,
                };
                axios
                    .post("/Icard/icardGenerate", data)
                    .then((res) => {
                        this.icard_data = res.data.icard_data;
                    })
                    .catch((error) => {
                        alert("Somthing went wrong!!!");
                    })
                    .finally(() => {
                        this.comp_load = false;
                    });
            },
        },
    };
</script>
<style scoped>
    wrap {
        align-self: flex-end;
    }
    h2 {
        font-size: 1.2em;
    }
    tr,
    td {
        width: 100%;
    }
    @media print {
        .pagebreak {
            page-break-before: always;
        }
        header,
        footer,
        nav,
        date {
            display: none !important;
            margin-top: none !important;
        }
        .no-display,
        .v-input__control,
        input[type="button"],
        input[type="submit"],
        input[type="reset"],
        #v-card {
            display: none !important;
            margin-top: none !important;
        }
        v-card {
            border: none !important;
            margin-top: none !important;
        }
        * {
            -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
        }
        @page {
            size: A4;
            margin-top: none !important;
            padding-top: none !important;
            size: 15.5in 15.5in;
        }
    }
     .box1 {
        border: 2px solid black;
    }
    .empimg{
    margin-bottom: 20px;
    margin-top: 8px;
    }
</style>
